export default {
  StorageExercise: {
    ExerciseRefer: 'Học liệu liên quan',
    Free: 'Miễn phí',
    EMIS: 'EMIS',
    CourseOutline: 'Đề cương khóa học',
    ViewCourse: 'Xem tiến độ khóa học',
    Search: 'Tìm kiếm',
    LearningProgress: 'Tiến độ học tập',
    TheSource: 'Nguồn',
    HocMai: 'HOCMAI.VN',
    Subject: 'Môn học',
    LearnNumbers: 'Số lượt học',
    Expiry: 'Hạn sử dụng',
    Purpose: 'Mục tiêu',
    Structure: 'Cấu trúc khóa học',
    Description: 'Mô tả khóa học',
    Requirement: 'Yêu cầu khóa học',
    Result: 'Kết quả khóa học',
    Participant: 'Đối tượng',
    IGiaoDuc: 'Học liệu số BGD',
    StartUse: 'Bắt đầu sử dụng',
    Category: 'Danh mục bài giảng',
    SourceEmis: 'Cộng đồng giáo viên',
    HanhTrangSo: 'NXB Giáo dục',
    ConsolidateKnowledge: 'Củng cố kiến thức',
    PracticeTitle: 'Luyện tập',
    YourPracticeCourses: 'Học liệu của bạn',
    YourFavoriteCourses: 'Học liệu bạn yêu thích',
    ViewMore: 'Xem thêm',
    ViewMoreExercise: 'Xem thêm học liệu',
    ViewMoreExerciseYouCare: 'Xem thêm học liệu bạn quan tâm',
    ViewMoreNewExercise: 'Khám phá thêm học liệu mới',
    FastFilter: 'Bộ lọc tìm kiếm nhanh',
    Bought: 'Đã mua',
    LessonNote: 'Ghi chú bài học',
    NotePlaceholder: 'Nhập ghi chú',
    Curriculum: 'Giáo trình',
    Minute: 'phút',
    ExerciseTree: 'bài tập',
    FreeLectures: 'Bài giảng miễn phí',
    DescriptionTry: 'Bạn được phép học thử <b class="text-accent-200">10</b> bài học đầu tiên của khóa học này<br>từ ngày <b class="text-accent-200">{startDate}</b> đến ngày <b class="text-accent-200">{endDate}</b>',
    DescriptionExchange: 'Bạn có thể học thử trước những bài giảng miễn phí <br> hoặc chọn Đăng ký học để xem được tất cả bài giảng của khóa học bạn nhé.',
    // DescriptionPackageCantUse: 'Bạn còn <b class="text-accent-200">0</b> thẻ khóa học<br>Vui lòng liên hệ nhà trường để biết thêm chi tiết',
    DescriptionRegistrationAll: 'Để xem được tất cả bài giảng của khóa học, vui lòng đăng ký học và <br> thực hiện theo hướng dẫn',
    DescriptionCardUsage: 'Bạn có muốn đổi 1 lượt dùng để đăng ký học tất cả bài giảng <br> thuộc khóa học này không?',
    DescriptionPackageCantUse: 'Bạn có muốn đổi 1 lượt dùng để đăng ký học tất cả bài giảng <br> thuộc khóa học này không?',
    // DescriptionTryOrBuy: 'Bạn còn <b class="text-accent-200">{timesUse}</b> thẻ khóa học, bạn có muốn muốn học thử bài học hay mở khóa ngay?',
    DescriptionTryOrBuy: 'Thoải mái học thử những bài giảng miễn phí của khóa học bạn nhé!',
    DescriptionRegistration: 'Chọn Đăng ký học để xem được tất cả bài giảng của khóa học<br>hoặc Tiếp tục học thử những bài giảng miễn phí bạn nhé.',
    DescriptionOnlyBuy: 'Bài học không nằm trong danh sách bài học thử. Bạn còn <b class="text-accent-200">{timesUse}</b> thẻ khóa học, nhấn xác nhận để sử dụng 1 thẻ đổi lấy khóa học',
    Notification: 'Thông báo',
    NotificationCardExpire: 'Thẻ khóa học của bạn đã hết lượt dùng',
    NotificationCardUsage: 'Thẻ khóa học của bạn còn {timesUse} lượt dùng',
    TrialExpired: 'Đã hết hạn học thử',
    NotificationTrialTime: 'Thông báo thời gian học thử',
    CourseNotOpen: 'Chưa mở khóa bài học',
    // CanNotTry: 'Bài học không nằm trong danh sách bài học thử',
    CanNotTry: 'Không thể học thử bài giảng này',
    NotificationFeedback: 'Bạn cảm thấy thế nào về khóa học?',
    NotificationVeryGood: 'Cảm ơn bạn đã yêu thích khóa học',
    DescriptionResistration: 'Bạn có muốn đăng ký học tất cả bài giảng của khóa học này không?',
    DescriptionContentFeedback: 'Bạn có thể cho chúng mình biết khóa học này có điểm gì chưa tốt không?',
    DescriptionFeedback: 'Bạn có thể chia sẻ cảm nhận về khóa học cùng chúng mình không:',
    Exchange: 'trao đổi',
    Toolbar: {
      Lesson: 'Bài học',
      Question: 'Trao đổi',
      Note: 'Ghi chú',
      Document: 'Bài tập',
      Description: 'Mô tả',
      Support: 'Hỗ trợ'
    },
    TemplateExpiredTrial: 'Khóa học sẽ hết hạn sau ngày {day}',
    LessonNotFound: 'Không tìm được bài học',
    ListExercise: 'Danh sách bài học',
    ExerciseExpired: 'Đã hết hạn học thử',
    ContinuePractice: 'Tiếp tục ôn luyện',
    SummaryPractice: 'Bài tập tổng hợp',
    Knowledge: 'Luyện tập',

    FixedKnowledge: 'Củng cố kiến thức',
    SeeMoreExercise: 'Xem thêm học liệu',
    SubjectMaths: 'Toán',
    SubjectLiterature: 'Văn',
    SubjectLiteraturePrimary: 'Tiếng Việt',
    SubjectEnglish: 'Tiếng Anh',
    // ExerciseExpired: 'Đã hết hạn học thử'

    TitleExercisePro: 'Đề thi PRO!',
    RegisterCountinueLearn: 'Đăng ký học để tiếp tục ôn luyện!',
    DescriptionFreeTurns: 'Bạn đã luyện hết 3 lượt miễn phí của ngày hôm nay mất rồi.<br>Vui lòng Đăng ký học để được ôn luyện không giới hạn, <br>hoặc quay lại vào ngay mai nhé!',
    DescriptionRegisterExercise: 'Bạn vui lòng chọn Đăng ký học để mở khóa<br> đề thi được đánh dấu PRO và ôn luyện không giới hạn nhé.',
    FailSnapShot: 'Chụp ảnh màn hình không thành công',
    DoExercise: 'Làm bài'
  }
}
